
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(webpack_sharing_(consume_default_(snapchat_snap\-design\-system\-(charts_snapchat_snap\-design\-syste\-db6541|icons_snapchat_snap\-design\-system\-icons)|react(\-dom_react\-dom|\-intl_react\-intl|_react)|emotion_css_emotion_css)|provide_default_emotion_css\-webpack_sharing_provide_default_shared_tracking\-w\-e0b1e3)|vendors\-node_modules_pnpm_antd_4_20_0_react\-dom_16_14_0_react_16_14_0__react_16_14_0_node_mod\-(d046ad|efdf27)|onboarding\-flows(|\-bizext)|((events\-manag|shared\-module\-controll)er|manage\-workflow|payments|personalized\-create)\-mfe|campaign\-lab\-app)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
